import { createStore, useStore } from 'zustand'

interface UserReviewsStore {
  sorting: string
  setSorting: (by: string) => void
  pagination: {
    limit: number
    offset: number
  }
  showNextReviews: () => void
  showOnlyInWebsiteLanguage: boolean
  setShowOnlyInWebsiteLanguage: (show: boolean) => void
  partyCompositionGroupId: string
  setPartyCompositionGroupId: (groupId: string) => void
}

export const userReviewsStore = createStore<UserReviewsStore>(set => ({
  sorting: '-date',
  setSorting: (by) => {
    set(() => ({
      sorting: by,
    }))
  },
  pagination: {
    limit: 10,
    offset: 0,
  },
  showNextReviews: () => {
    set(({ pagination }) => ({
      pagination: {
        ...pagination,
        limit: pagination.limit + 20,
      },
    }))
  },
  showOnlyInWebsiteLanguage: false,
  setShowOnlyInWebsiteLanguage: (show) => {
    set(() => ({
      showOnlyInWebsiteLanguage: show,
    }))
  },
  partyCompositionGroupId: 'all',
  setPartyCompositionGroupId: (id) => {
    set(() => ({
      partyCompositionGroupId: id,
    }))
  },
}))

export const useUserReviewsStore = () => useStore(userReviewsStore)
